import complianceService from "@/services/complianceService";
import router from "../../router/index";

const getDefaultState = () => {
    return {
        complianceList: [],
        complianceDetails: [],
        userCompliance: null,
        compFetched: null,
        userOnlineCompliance: null,
        complianceUserDetails: [],
        loading: false,
        visitId: null,
        areaId: null,
        userId: null,
        userTypeId: null,
        entityId: null,
        complianceCreated: null,
        expiryMsg: null,
    };
};

export const state = getDefaultState();

export const actions = {
    fetchUserOnlineCompliance({ commit }, payload) {
        commit("setCompFetched", false);
        return new Promise((resolve) => {
            complianceService
                .getUserOnlineCompliance(payload)
                .then((data) => {
                    resolve(data);
                    console.log(data.data.data.compliances);
                    commit("setUserCompliance", data.data.data.compliances);
                    commit("setCompFetched", true);
                    commit("setLoading", false);
                    // commit("setUserCompliance", data.data.data.compliances);
                    commit("setVisitId", data.data.data.data.visitId);
                    commit("setAreaId", data.data.data.data.areaId);
                    commit("setUserId", data.data.data.data.userId);
                    commit("setEntityId", data.data.data.data.entityId);
                    commit("setUserTypeId", data.data.data.data.usertypeId);
                    if (data.data.data.data.visitMetadata.is_expired && JSON.parse(data.data.data.data.visitMetadata.is_expired)) {
                        let msg = "Your compliance link has expired because ";
                        if (data.data.data.data.visitMetadata.reason == "VISIT_REJECTED") msg += "your visit has not been approved. ";
                        else if (data.data.data.data.visitMetadata.reason == "VISIT_DELETED") msg += "your visit has been deleted. ";
                        else if (data.data.data.data.visitMetadata.reason == "VISIT_EXPIRED" || data.data.data.data.visitMetadata.reason == "SCAN_EXPIRED") msg += "you missed your appointment. ";
                        else msg += "you have already arrived at the area. ";
                        msg += "Please contact the system admin for further details."
                        commit("setExpiryMsg", msg);
                        router.push("/compliance-link-expired");
                        // return;
                    }
                })
                .catch(() => {
                    commit("setExpiryMsg", "Your compliance link has expired. Please contact the system admin for further details.");
                    router.push("/compliance-link-expired");
                    commit("setCompFetched", true);
                    // this._vm.$toast.error(err.data.data);
                });
        });
    },

    createUserOnlineCompliance({ state, commit }, params) {
        commit("setComplianceCreated", false);
        let obj = {};
        let formData = new FormData();
        if (params.bodyRequest.vaccine) {
            formData.append("document[complianceId]", params.bodyRequest.complianceId);
            formData.append("document[notes]", params.bodyRequest.notes);
            formData.append("document[document_id]", params.bodyRequest.document_id ? params.bodyRequest.document_id : "");
            formData.append("isCompleted", params.bodyRequest.isCompleted);
            formData.append("entityId", state.entityId);
            formData.append("userId", state.userId);
            formData.append("scan[areaId]", state.areaId);
            formData.append("scan[userTypeId]", state.userTypeId);
            formData.append("scan[visitId]", state.visitId);
            formData.append("document[fileAttach]", params.bodyRequest.uploadedFile);
            // formData.append("document[data][document]",document.id) //#Removed from UI
            formData.append("document[data][entity_id]", state.entityId);
            // formData.append("document[data][input_type]",handleCovidType()) //input_type == ?
            // formData.append("document[data][row_data]",'') //#(Currently <scanned qr code>)Removed from UI
            formData.append("document[data][expiry_date]", params.bodyRequest.data.expiry_date);
            formData.append("document[data][metadata][protocol]", params.bodyRequest.data.metadata.protocol);
            formData.append("document[data][metadata][certificateModel][extraData]", params.bodyRequest.data.metadata.certificateModel.extraData);
            formData.append("document[data][metadata][certificateModel][dateOfBirth]", params.bodyRequest.data.metadata.certificateModel.dateOfBirth);
            formData.append("document[data][metadata][certificateModel][kid]", params.bodyRequest.data.metadata.certificateModel.kid);
            formData.append("document[data][metadata][certificateModel][person][familyName]", params.bodyRequest.data.metadata.certificateModel.person.familyName);
            formData.append("document[data][metadata][certificateModel][person][givenName]", params.bodyRequest.data.metadata.certificateModel.person.givenName);
            formData.append("document[data][metadata][certificateModel][person][standardisedFamilyName]", params.bodyRequest.data.metadata.certificateModel.person.standardisedFamilyName);
            formData.append("document[data][metadata][certificateModel][person][standardisedGivenName]", params.bodyRequest.data.metadata.certificateModel.person.standardisedGivenName);
            formData.append("document[data][metadata][certificateModel][signature]", params.bodyRequest.data.metadata.certificateModel.signature);
            formData.append("document[data][metadata][generalVerificationResult]", params.bodyRequest.data.metadata.generalVerificationResult);
            formData.append("document[data][metadata][greenCertificatData][expirationTime]", params.bodyRequest.data.metadata.greenCertificatData.expirationTime);
            formData.append("document[data][metadata][greenCertificatData][issuedAt]", params.bodyRequest.data.metadata.greenCertificatData.issuedAt);
            formData.append("document[data][metadata][greenCertificatData][issuingCountry]", params.bodyRequest.data.metadata.greenCertificatData.issuingCountry);
            formData.append("document[data][metadata][type]", params.bodyRequest.data.metadata.type);
            formData.append("document[data][metadata][fileAttach]", params.bodyRequest.uploadedFile);
            formData.append("document[data][metadata][notes]", params.bodyRequest.data.metadata.notes ? params.bodyRequest.data.metadata.notes : "");
            if (params.bodyRequest.data.type == "covid_vaccine") {
                for (let i = 0; i < params.bodyRequest.data.metadata.certificateModel.vaccinations.length; i++) {
                    for (let key of Object.keys(params.bodyRequest.data.metadata.certificateModel.vaccinations[i])) {
                        formData.append(`document[data][metadata][certificateModel][vaccinations][${i}][${key}]`, params.bodyRequest.data.metadata.certificateModel.vaccinations[i][key]);
                    }
                }
            } else {
                for (let i = 0; i < params.bodyRequest.data.metadata.certificateModel.tests.length; i++) {
                    for (let key of Object.keys(params.bodyRequest.data.metadata.certificateModel.tests[i])) {
                        formData.append(`document[data][metadata][certificateModel][tests][${i}][${key}]`, params.bodyRequest.data.metadata.certificateModel.tests[i][key]);
                    }
                }
            }
            // formData.append("document[data][notes]",'')  //#Removed from UI
            formData.append("document[data][start_date]", params.bodyRequest.data.start_date);
            formData.append("document[data][user_id]", params.bodyRequest.data.user_id);
            formData.append("document[data][type]", params.bodyRequest.data.type);
        }
        obj = params.bodyRequest.vaccine ? formData
            // {
            //   document: {
            //     complianceId: params.bodyRequest.complianceId,
            //     notes: params.bodyRequest.notes,
            //     document_id: params.bodyRequest.document_id,
            //     data: params.bodyRequest.data,
            //   },
            //   entityId: state.entityId,
            //   userId: state.userId,
            //   isCompleted: params.bodyRequest.isCompleted,
            //   isWrong: params.bodyRequest.isWrong,
            //   scan: {
            //     visitId: state.visitId,
            //     areaId: state.areaId,
            //     userTypeId: state.userTypeId,
            //   },
            // }
            : {
                compliances: [{
                    answer: params.bodyRequest.answer,
                    complianceId: params.bodyRequest.answer[0].complianceId,
                    name: params.bodyRequest.name
                }],
                entityId: state.entityId,
                userId: state.userId,
                isCompleted: params.bodyRequest.isCompleted,
                isWrong: params.bodyRequest.isWrong,
                scan: {
                    visitId: state.visitId,
                    areaId: state.areaId,
                    userTypeId: state.userTypeId,
                }
            }
        return new Promise((resolve) => {
            complianceService
                .createUserOnlineCompliance({obj, server_url: params.server_url})
                .then((data) => {
                    resolve(data);
                    console.log('createUserOnlineCompliance', data);
                    commit("setComplianceCreated", true);
                    // this._vm.$toast.success("Compliance Updated");
                    // router.push('/compliances');
                    // commit("setUserCompliance", data.data);

                    // dispatch("fetchComplianceList");
                })
                .catch((err) => {
                    // commit("setLoading", false);
                    err.status != 401 && this._vm.$toast.error(err.data.message);
                });
        });
    },

    checkIfStandalone({ commit }, payload) {
        if (!payload.onlineCompliance) return true;
        return new Promise((resolve) => {
            complianceService
                .getUserOnlineCompliance(payload)
                .then((data) => {
                    resolve(data);
                    // console.log(data.data.data.data);
                    if (data.data.data.data.visitMetadata.is_expired && JSON.parse(data.data.data.data.visitMetadata.is_expired)) {
                        let msg = "Your compliance link has expired because ";
                        if (data.data.data.data.visitMetadata.reason == "VISIT_REJECTED") msg += "your visit has not been approved. ";
                        else if (data.data.data.data.visitMetadata.reason == "VISIT_DELETED") msg += "your visit has been deleted. ";
                        else if (data.data.data.data.visitMetadata.reason == "VISIT_EXPIRED" || data.data.data.data.visitMetadata.reason == "SCAN_EXPIRED") msg += "you missed your appointment. ";
                        else msg += "you have already arrived at the area. ";
                        msg += "Please contact the system admin for further details."
                        commit("setExpiryMsg", msg);
                        router.push("/compliance-link-expired");
                        // return;
                    }
                })
                .catch(() => {
                    commit("setExpiryMsg", "Your compliance link has expired. Please contact the system admin for further details.");
                    // let msg = "Standalone";
                    router.push("/compliance-link-expired");
                    // this._vm.$toast.error(err.data.data);
                });
        });
    },

    setCompExpiryMsg({ commit }, msg) {
        commit("setExpiryMsg", msg);
    },
};

export const mutations = {
    resetComplianceState(state) {
        // Merge rather than replace so we don't lose observers
        Object.assign(state, getDefaultState())
    },
    setComplianceList(state, payload) {
        state.complianceList = payload;
    },
    setComplianceDetails(state, payload) {
        state.complianceDetails = payload;
    },
    setLoading(state, payload) {
        state.loading = payload;
    },

    setUserCompliance(state, payload) {
        state.userCompliance = payload;
    },

    setCompFetched(state, payload) {
        state.compFetched = payload;
    },

    setComplianceUserDetails(state, payload) {
        state.complianceUserDetails = payload;
    },

    setVisitId(state, payload) {
        state.visitId = payload;
    },

    setAreaId(state, payload) {
        state.areaId = payload;
    },

    setUserId(state, payload) {
        state.userId = payload;
    },

    setUserTypeId(state, payload) {
        state.userTypeId = payload;
    },

    setEntityId(state, payload) {
        state.entityId = payload;
    },

    setComplianceCreated(state, payload) {
        console.log('set', payload);
        state.complianceCreated = payload;
    },

    setExpiryMsg(state, payload) {
        state.expiryMsg = payload;
    },
};

export const getters = {
    getComplianceList(state) {
        return state.complianceList;
    },
    getComplianceDetails(state) {
        return state.complianceDetails;
    },
    getLoading(state) {
        return state.loading;
    },

    getUserCompliance(state) {
        return state.userCompliance;
    },

    getCompFetched(state) {
        return state.compFetched;
    },

    getComplianceUserDetails(state) {
        return state.complianceUserDetails;
    },

    getVisitId(state) {
        return state.visitId;
    },

    getAreaId(state) {
        return state.areaId;
    },

    getUserId(state) {
        return state.userId;
    },

    getUserTypeId(state) {
        return state.userTypeId;
    },

    getEntityId(state) {
        return state.entityId;
    },

    getComplianceCreated(state) {
        return state.complianceCreated;
    },

    getExpiryMsg(state) {
        return state.expiryMsg;
    },
};